import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClientUrlPipe } from 'mbs-ui-shared@pipes';
import { BuildTypeDisplayPipe } from './pipes/BuildTypeDisplay.pipe';
import { BoolDisplayPipe } from './pipes/bool-display.pipe';
import { MonitoringPlanTypePipe } from './pipes/monitoringPlanType.pipe';
import { ComputerOsIconPipe } from './pipes/os-icon.pipe';
import { PlanStatusPipe } from './pipes/plan-status.pipe';
import { PlanTypePipe } from './pipes/plan-type.pipe';
import { StorageTypeIconPipe } from './pipes/storage-type-icon.pipe';
import { TimeSpanPipe } from './pipes/time-span.pipe';
import { VirtualMachineTypeDisplayPipe } from './pipes/virtual-machine-type-display.pipe';

const exportsArray = [
  BoolDisplayPipe,
  BuildTypeDisplayPipe,
  ClientUrlPipe,
  ComputerOsIconPipe,
  MonitoringPlanTypePipe,
  PlanStatusPipe,
  PlanTypePipe,
  TimeSpanPipe,
  StorageTypeIconPipe,
  VirtualMachineTypeDisplayPipe
];

@NgModule({
  imports: [CommonModule, ...exportsArray],
  exports: exportsArray
})
export class UtilsPipeModule {}
